"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Status = exports.FunctionId = void 0;
var FunctionId;
(function (FunctionId) {
    FunctionId[FunctionId["Undefined"] = 0] = "Undefined";
    FunctionId[FunctionId["SaveReservation"] = 1] = "SaveReservation";
    FunctionId[FunctionId["RemoveReservaton"] = 2] = "RemoveReservaton";
    FunctionId[FunctionId["LoadReservations"] = 3] = "LoadReservations";
    FunctionId[FunctionId["LoadSettings"] = 4] = "LoadSettings";
    FunctionId[FunctionId["SaveSettings"] = 5] = "SaveSettings";
    FunctionId[FunctionId["LoadReservationStatistics"] = 6] = "LoadReservationStatistics";
    FunctionId[FunctionId["CheckReservationAvailability"] = 7] = "CheckReservationAvailability";
    FunctionId[FunctionId["LoadMenu"] = 8] = "LoadMenu";
    FunctionId[FunctionId["SaveMenu"] = 9] = "SaveMenu";
    FunctionId[FunctionId["GateApi"] = 10] = "GateApi";
})(FunctionId || (exports.FunctionId = FunctionId = {}));
var Status;
(function (Status) {
    Status[Status["Ok"] = 0] = "Ok";
    Status[Status["InternalError"] = 1] = "InternalError";
    Status[Status["BadRequest"] = 2] = "BadRequest";
    Status[Status["Unimplemented"] = 3] = "Unimplemented";
    Status[Status["Something"] = 4] = "Something";
    Status[Status["Unauthorized"] = 5] = "Unauthorized";
    Status[Status["DeadlineExceeded"] = 6] = "DeadlineExceeded";
})(Status || (exports.Status = Status = {}));
//# sourceMappingURL=types.js.map